import React from "react";
import TextInput from "../../../core/form/TextInput";

let FacilityWebsiteField = ({loading = false}) => {

    return <TextInput
        name='website'
        label='form.facility.website'
        required={true}
        loading={loading}
    />

}

export default FacilityWebsiteField